import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Row, Popover, Whisper, Button } from "rsuite";
import { Link } from "react-router-dom";
import Loading from "../../Loading/Loading";
import { reset } from "../../Features/Template/TemplateSlice";

import "../assets/css/view-asset-blocks.css";
import convertToUserTimeZone from "../../../hooks/convertToUserTimeZone";

const ImageStyle = (width, height) => {
  return {
    width,
    height,
  };
};

class RecentTemplates extends Component {
  render() {
    let { templates, loading, reset } = this.props;
    // FIXME
    // console.log(templates);

    return (
      <div>
        <Row>
          <Col md={24}>
            <h5 className="assets_recent_emails">Recent Templates</h5>
          </Col>
        </Row>

        <Row className="new-campaign-row ">
          <Col
            md={24}
            className="grid-view-filter-template-image block-bg-font-color"
          >
            {!loading ? (
              <>
                {templates.template.length > 0 ? (
                  <>
                    {templates.template.map((val) => (
                      <div className="grid pointer-for" key={val.template_id}>
                        <Link
                          to={`/assetlibrary/edit/template/${val.template_id}`}
                          style={{ textDecoration: "none" }}
                        >
                          <div className="rs-panel rs-panel-default rs-panel-bordered rs-panel-shaded panel-remove-border">
                            <div className="ImageResize ">
                              <img
                                className="email_images"
                                src={`${
                                  val.template_img_path
                                }?${Math.random()}`}
                                data-id={val.template_id}
                                alt={val.template_name}
                                title={val.template_name}
                                style={ImageStyle("100%", "100%")}
                              />
                            </div>

                            <div
                              role="rowheader"
                              className="rs-panel-heading asset-name"
                              style={{ padding: "10px 10px" }}
                              tabIndex="-1"
                            >
                              <b>
                                {val.template_name.length < 15
                                  ? val.template_name
                                  : `${val.template_name.substring(0, 15)}...`}
                              </b>
                              <Whisper
                                trigger="hover"
                                placement="topEnd"
                                speaker={
                                  <Popover
                                    title="Info"
                                    visible
                                    style={{ color: "#000" }}
                                  >
                                    <b> Created By</b> :{" "}
                                    {val.template_created_by}
                                    <br />
                                    <b>Modified By</b> :
                                    {val.template_modified_by}
                                    <br />
                                    <b>Created At </b>:{" "}
                                    {convertToUserTimeZone(
                                      val.template_created_at
                                    )}
                                    <br />
                                    <b>Modified At </b>:
                                    {convertToUserTimeZone(
                                      val.template_modified_at
                                    )}
                                    <br />
                                    <b>Category </b> : {val.template_category}
                                  </Popover>
                                }
                              >
                                <Button
                                  appearance="subtle"
                                  style={{
                                    float: "right",
                                    padding: 0,
                                    color: "#000",
                                  }}
                                >
                                  <i
                                    className="fa fa-info-circle"
                                    aria-hidden="true"
                                  ></i>
                                </Button>
                              </Whisper>
                            </div>
                            <div
                              className="rs-panel-body"
                              style={{ padding: 10 }}
                            >
                              {/* <p>
                                <small className="asset-name">
                                  <b>Category : </b> {val.template_category}
                                </small>
                              </p> */}
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </>
                ) : (
                  <Row style={{ marginTop: 20 }}>
                    <Col md={7}></Col>
                    <Col md={7} style={{ textAlign: "center" }}>
                      <h5>No Template Found !</h5> <br />
                      <Link
                        onClick={() => reset()}
                        className="link-color-font"
                        to="/createnewproject/create/template/info"
                        style={{ fontSize: 25, cursor: "pointer" }}
                      >
                        Click to Create
                      </Link>
                    </Col>
                    <Col md={7}></Col>
                  </Row>
                )}
              </>
            ) : (
              <Loading />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  templates: state.AssetSlice.templates,
});

const mapDispatchToProps = (dispatch) => ({
  reset: () => dispatch(reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentTemplates);
